import ModalInformation from "@/app/components/ui/Modals/Information";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { IViewCommentsModalProps } from "../interface";

interface EMRQuickViewModalState {
  emrId: string;
}

const EMRQuickViewModal: React.FC<IViewCommentsModalProps> = () => {
  const { emrId } = useModalState("EMR_QUICK_VIEW_MODAL") as EMRQuickViewModalState;

  return (
    <ModalInformation
      dialogClassName="sm:my-8 sm:w-full sm:max-w-4xl sm:p-6 h-[500px] overflow-scroll"
      modalId="EMR_QUICK_VIEW_MODAL"
      title={`EMR Quick View`}
    >

    </ModalInformation>
  );
};
export default EMRQuickViewModal;
